import React from 'react';
import BusinessPlanHeaderHelper from './BusinessPlanHeaderHelper';

const BusinessPlanHeader = () => (
  <div className="business-map-header">
    <h1 className="col-md-7">The Most Entrepreneurial States of 2017</h1>
    <div className="business-map-info-section">
      <BusinessPlanHeaderHelper />
      <div className="col-md-5 methodology">
        <div className="methodology-header">
          Methodology
        </div>
        <div className="methodology-content">
          With 2018 upon us, our team wanted to create a ranking of the most
          entrepreneurial states in 2017. To do this, we equated
          entrepreneurship with the creation of business plans. We used internal
          data from Google Analytics to determine the total number of FormSwift
          users who completed a business plan in each state in 2017. We subtracted
          the percentage of people who exited the page before completing the form
          from our total number of page users to account only for completed
          business plans. We then obtained the total population of each state
          (as of 2016) from the US Census Bureau, with which calculated the
          number of individuals per 100,000 that completed business plans in each state.
        </div>
      </div>
    </div>
  </div>
);

export default BusinessPlanHeader;



// WEBPACK FOOTER //
// ./src-react/UsaMap/headers/BusinessPlanHeader.jsx